/**
 * Enums and constants for the application
 * Centralized location for all hard-coded strings and numbers
 */

// File Sync Status
export enum FileSyncStatus {
  UP_TO_DATE = 'up-to-date',
  BEHIND = 'behind',
  NEWER = 'newer',
  DELETED = 'deleted',
  NEW = 'new',
  UNKNOWN = 'unknown',
}

// Project Member Roles
export enum ProjectMemberRole {
  OWNER = 'OWNER',
  COLLABORATOR = 'COLLABORATOR',
  READ_ONLY = 'READ_ONLY',
}

// Project Invite Status
export enum ProjectInviteStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
}

// Subscription Tiers
export enum SubscriptionTier {
  FREE = 'free',
  BASIC = 'basic',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
}

// Subscription Status
export enum SubscriptionStatus {
  ACTIVE = 'active',
  TRIALING = 'trialing',
  PAST_DUE = 'past_due',
  CANCELLED = 'cancelled',
}

// Sync Operations
export enum SyncOperation {
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
  DELETE = 'delete',
}

// File Categories
export enum FileCategory {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
  PDF = 'pdf',
  ARCHIVE = 'archive',
  DAW = 'daw',
  FILE = 'file',
}

// Progress Percentages (common values)
export const ProgressPercentage = {
  START: 0,
  QUARTER: 25,
  THIRD: 33,
  HALF: 50,
  TWO_THIRDS: 67,
  THREE_QUARTERS: 75,
  FOUR_FIFTHS: 80,
  NINE_TENTHS: 90,
  COMPLETE: 100,
} as const;

// DAW File Extensions
export const DAW_FILE_EXTENSIONS = [
  '.als',
  '.logicx',
  '.ptf',
  '.ptx',
  '.cpr',
  '.flp',
  '.rpp',
] as const;

// Ignored Files (for file system operations)
export const IGNORED_FILES = [
  '.DS_Store', // macOS system file
  'Thumbs.db', // Windows system file
  'desktop.ini', // Windows system file
  'Icon\r', // macOS custom folder icon (Icon + carriage return, created by macOS/Ableton)
] as const;

// Common File Extensions by Category
export const FILE_EXTENSIONS = {
  IMAGE: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'],
  VIDEO: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'],
  AUDIO: ['mp3', 'wav', 'aac', 'flac', 'ogg', 'm4a'],
  DOCUMENT: ['doc', 'docx', 'txt', 'rtf'],
  ARCHIVE: ['zip', 'rar', '7z', 'tar', 'gz'],
} as const;

// Subscription Tier Prices
export const SUBSCRIPTION_TIER_PRICES = {
  FREE: 0,
  BASIC: 4.99,
  PRO: 9.99,
  ENTERPRISE: 29.99,
} as const;

// Storage Limits (in bytes)
export const STORAGE_LIMITS = {
  FREE: 500 * 1024 * 1024, // 500 MB
  BASIC: 10 * 1024 * 1024 * 1024, // 10 GB
  PRO: 20 * 1024 * 1024 * 1024, // 20 GB
  ENTERPRISE: 100 * 1024 * 1024 * 1024, // 100 GB
} as const;
